export default "__VITE_ASSET__BXYVBD_y__"